import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBDrvLicenceNumberSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="drvLicenceNumber"
            formName="drvLicenceNumber"
            label="drvLicenceNumber"
        />
    )
}

export default CBDrvLicenceNumberSearchFilter;